import { useEffect, useRef, useState } from "react";
import { useStore } from "../../store/store";
import gsap from "gsap";
import s from "./LoaderLetterReveal.module.scss";
import CustomEase from "gsap/dist/CustomEase";
import { titleInEase } from "../../utils/Eases";

const LoaderLetterReveal = ({ children, onComplete }) => {
  const letterWrapperRef = useRef();
  const enterTimeline = useRef();

  const opacityTimelineRef = useRef();

  const [enterCompleted, setEnterCompleted] = useState(false);

  const [spans, setSpans] = useState([]);
  const loadingProgress = useStore((state) => state.loadingProgress);
  const setLoadingScreen = useStore((state) => state.setLoadingScreen);

  useEffect(() => {
    const spansArray = [];
    const letters = children.split("");
    letters.forEach((letter) => {
      const span = document.createElement("span");
      span.innerHTML = letter;
      span.classList.add(s.letter);
      span.setAttribute("data-animation", "");

      if (letter.toLowerCase() === "o") {
        span.classList.add("salmon");
        span.removeAttribute("data-animation");
        span.setAttribute("data-rotation", "");
      }
      if (letter.toLowerCase() === "n") {
        span.classList.add("yellow");
        span.removeAttribute("data-animation");
        span.setAttribute("data-rotation", "");
      }

      letterWrapperRef.current.appendChild(span);
      spansArray.push(span);
    });

    setSpans(spansArray);
  }, []);

  useEffect(() => {
    if (spans.length === 0) return;
    enterTimeline.current = gsap.timeline({
      onComplete: () => setEnterCompleted(true),
    });
    opacityTimelineRef.current = gsap.timeline({ paused: true });

    const lettersToTranslate = document.querySelectorAll(
      "#loader [data-animation]"
    );
    const lettersToRotate = document.querySelectorAll(
      "#loader [data-rotation]"
    );

    opacityTimelineRef.current.fromTo(
      spans,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        stagger: 1 / 7,
      }
    );

    enterTimeline.current.fromTo(
      lettersToTranslate,
      {
        // rotateX: -90,
        // z: 100,
        y: "100%",
        opacity: 0,
        transformOrigin: "bottom center",
      },
      {
        ease: titleInEase,
        y: "15%",
        opacity: 1,
        stagger: 0.2,
        // rotateX: 0,
        z: 0,
      }
    );

    enterTimeline.current.fromTo(
      lettersToRotate,
      {
        transformOrigin: "center center",
        rotateX: -270,
        // z: 100,
        opacity: 0,
        y: "15%",
      },
      {
        ease: titleInEase,
        opacity: 1,
        duration: 1.5,
        stagger: 0.5,
        rotateX: 0,
        // z: 0,
      },
      "<"
    );

    // timelineRef.current.to(spans, {
    //   stagger: 0.03,
    //   scaleY: 0.9,
    //   y: -25,
    //   duration: 0.5,
    // });

    // timelineRef.current.to(
    //   spans,
    //   {
    //     stagger: 0.03,
    //     y: 25,
    //     duration: 0.5,
    //     scaleY: 1,
    //     ease: "back.inOut(2)",
    //   },
    //   0.5
    // );

    // timelineRef.current.to(
    //   spans,
    //   {
    //     stagger: 0.03,
    //     y: 0,
    //   },
    //   1
    // );
  }, [spans]);

  useEffect(() => {
    if (enterCompleted === true && loadingProgress === 1) {
      // opacityTimelineRef.current.pause();

      gsap.to(spans, {
        stagger: {
          amount: 0.3,
          from: "end",
        },

        y: "-100%",

        ease: CustomEase.create("loader_out", "0.66, 0.00, 0.86, 0.00"),
        onComplete: () => {
          enterTimeline.current.pause();
          enterTimeline.current.kill();
          opacityTimelineRef.current.kill();
          onComplete();
        },
      });

      return;
    }

    if (!opacityTimelineRef.current) return;
    // opacityTimelineRef.current.progress(loadingProgress);
  }, [enterCompleted, loadingProgress]);

  return <div ref={letterWrapperRef} className={s.letterWrapper}></div>;
};

export default LoaderLetterReveal;
